export * from './functions';



// WEBPACK FOOTER //
// ./src/components/Modal/functions/ModalInactivity/index.ts